<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">MesLivraison</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">Liste des MesLivraison</h3>
        <div class="card-options d-flex gap-2">
          <button class="btn btn-outline-success btn-sm">
            <i class="fe fe-plus-circle me-1"></i> Ajouter
          </button>
          <button class="btn btn-outline-info btn-sm">
            <i class="fe fe-download me-1"></i> Exporter
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="mb-3 d-flex">
          <input type="text" class="form-control" placeholder="Recherche..." />
        </div>

        <div class="table-responsive">
          <table class="table table-bordered table-hover text-nowrap mb-0">
            <thead class="border-top">
              <tr>
                <th>#</th>
                <th>Colonne 1</th>
                <th>Colonne 2</th>
                <th>Colonne 3</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in 5" :key="n">
                <td>{ '{' } n { '}' }</td>
                <td>Exemple</td>
                <td>Exemple</td>
                <td>Exemple</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MesLivraisons',
};
</script>
